// Site network-defaults (computed proposal), keyed by bare site_slug:
//   GET /api/v1/sites/{site_slug}/network-defaults
// Read = fleet. 404 site_not_found / 422 unmet-prereq (no_generated_vlans,
// no_mgmt_vlan, allocation_missing, …) are states, not retryable errors.

import { request, type ApiResponse } from "../client";
import type { NetworkDefaultsOut } from "../types/networkDefaults";

export const networkDefaults = {
  get: (siteSlug: string): Promise<ApiResponse<NetworkDefaultsOut>> =>
    request<NetworkDefaultsOut>(
      "GET",
      `/api/v1/sites/${encodeURIComponent(siteSlug)}/network-defaults`,
    ),
};
